import styled from 'styled-components/macro';
import { information } from '../../../assets/icons';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AccrualsWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
  border-radius: 12px;
  background-color: #f8f9fa;
  border: 1px solid #ced5de;
  min-height: 20px;
`;

export const RowParamBlock = styled.div`
  display: flex;
  align-self: stretch;
`;

export const Title = styled.div`
  color: #495466;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  min-width: 248px;
  padding: 10px 0;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const UpperBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #495466;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BottomBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1f2939;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

export const StyledSpan = styled.span<{ debt: boolean }>`
  color: ${(props) => (props.debt ? '#e53e3e' : '#16a24a')};
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e4e8ee;
`;

export const DebtMessageWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0.2;
`;

export const DebtMessage = styled.span`
  font-size: 50px;
  color: #697180;
`;

export const InfoIcon = styled.img.attrs({ src: information })`
  width: 48px;
  height: 48px;
  transform: rotate(180deg);
`;
